"use client";

import { ChangeEvent, useMemo } from "react";

import { useAutoMaskContext } from "@/providers";
import { calculatePercent } from "@/utils/calculatePercent";
import { cn } from "@/utils/cn";

const MIN_RANGE = 1;
const MAX_RANGE = 30;
const STEP = 0.1;

export const BrushSize = () => {
  const { isShowDraw, brushSize, setBrushSize } = useAutoMaskContext();

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const val = Number(event.currentTarget.value);

    setBrushSize(val);
  };

  const sliderPercent = useMemo(
    () => calculatePercent(brushSize, [MIN_RANGE, MAX_RANGE]),
    [brushSize],
  );

  return (
    <div
      className={cn(
        "grid w-full items-center gap-4 rounded-xl bg-regular px-3 transition-padding-grid-rows",
        isShowDraw
          ? "mb-4 grid-rows-[1fr] py-2 opacity-100"
          : "grid-rows-[0fr] opacity-0",
      )}
    >
      <div
        className={cn(
          "flex min-h-0 flex-col duration-300",
          !isShowDraw && "pointer-events-none opacity-0",
          isShowDraw && "delay-200",
        )}
      >
        <div
          className={cn(
            "relative my-4 flex h-2 min-h-0 w-full items-center justify-center rounded-sm bg-regular-foreground/20",
          )}
        >
          <input
            type="range"
            min={MIN_RANGE}
            max={MAX_RANGE}
            step={STEP}
            value={brushSize}
            className={cn(
              "m-0 h-8 w-full touch-none appearance-none rounded-full border-0 bg-transparent p-0 outline-0",
              "input-thumb:size-8 input-thumb:cursor-ew-resize input-thumb:appearance-none input-thumb:rounded-full input-thumb:border-0 input-thumb:bg-primary",
              "input-track:bg-transparent",
            )}
            onChange={onChange}
            disabled={!isShowDraw}
          />
          <div
            className="pointer-events-none absolute top-0 left-0 h-2 rounded-sm bg-primary"
            style={{ width: `${sliderPercent}%` }}
          />
        </div>
      </div>
    </div>
  );
};
